import {css} from 'lit';
export const styles = css`:host{display:inline-block}`;
export default styles;
